/*
 * util.js 公共方法
 */
import Config from '@/constants/config';
import md5 from 'md5';

// 检测是否为移动端
export const checkDeviceType = () => {
  const pixelRatio = window.devicePixelRatio || 1;
  const ua = navigator.userAgent.toLowerCase();
  if ((/(iPhone|iPod|Android|ios|ipad|Windows Phone|SymbianOS)/gi).test(ua) && (window.innerWidth <= 736 && (window.screen.width <= 736 || pixelRatio >= 2))) {
    if ((/MicroMessenger/i).test(ua)) {
      return Config.DEVICE_WECHAT;
    }
    return Config.DEVICE_MOBILE;
  }
  return Config.DEVICE_PC;
};

// 转义 Url 中的特殊字符
export const encodeUriQuery = val => encodeURIComponent(val)
  .replace(/%40/gi, '@')
  .replace(/%3A/gi, ':')
  .replace(/%24/g, '$')
  .replace(/%3D/gi, '=')
  .replace(/%26/gi, '&')
  .replace(/%2C/gi, ',');

/**
 * 上报 获取公共参数
 * @returns {{}}
 */
export const getReportCommonParam = (reportEvent) => {
  const configParamStr = {
    product_name: {
      pc: 'Mobile_WebSite_AppStore',
      mob: 'PC_WebSite_AppStore',
      other: '上报异常：未知设备',
    }
  }
  const timestamp = parseInt(new Date().getTime() / 1000);
  const browserObj = getBrowser() || { browser: 'unknown', version: 'unknown' };
  const osInfo = detectOS();
  const common_params = {
    timestamp: timestamp,
    ip: null,
    url: location.href,
    user_agent: navigator.userAgent,
    referer: location.href, // 事件发生来源网页
    resolution: `${screen.width} * ${screen.height}`,
    os: osInfo.os,
    os_version: osInfo.osVersion,
    product_name: null,
    browser: browserObj.browser,
    browser_version: browserObj.version,
    session_source: null,
  }

  const device_type = checkDeviceType();
  if (device_type === Config.DEVICE_MOBILE || device_type === Config.DEVICE_WECHAT) {
    common_params.product_name = configParamStr.mob;
  } else if (device_type === Config.DEVICE_PC) {
    common_params.product_name = configParamStr.pc;
  } else {
    // 理论上不会发生
    common_params.product_name = configParamStr.other;
  }
  if (Config.REPORT_EVENT[reportEvent]) {
    Object.assign(common_params, Config.REPORT_EVENT[reportEvent]);
  } else {
    throw new Error('REPORT_EVENT中，未添加当前事件必要的公共参数。');
  }
  return common_params;
};

/**
 * 获取 对应事件 上报参数
 * 统一管理配置 定制事件 参数
 * @returns {{}}
 */
export const getReportCustomParams = (reportEvent, callback) => {
  let custom_params = {};
  if (typeof callback === 'function') {
    custom_params = callback();
  }
  return custom_params;
}

/**
 * 汇总 上报参数
 */
export const sendReportData = (reportEvent, callback) => {
  const common_params = getReportCommonParam(reportEvent);
  const custom_params = getReportCustomParams(reportEvent, callback);
  return { common_params, custom_params };
}

export const detectOS = () => {
  const UA = navigator.userAgent;
  const osInfoStr = UA.split('/').splice(1, 1)[0] || '';
  let os, osVersion;
  const osInfo = /(Android.*?);/.exec(UA);
  if (osInfo !== null) {
    os = osInfo[1];
    const osVersionInfo = /\s+?(\d.+\d)/.exec(os);
    if (osVersionInfo !== null) {
      osVersion = osVersionInfo[1];
    }
  }
  return { os: os || osInfoStr, osVersion: osVersion || osInfoStr };
}

export const getBrowser = () => { // 获取浏览器名
  const ifWeChat = checkDeviceType() === Config.DEVICE_WECHAT
  var rUC = /UCBrowser|UCWEB/; // UC
  var rQQ = /QQBrowser|TencentTraveler|MQQBrowser/; // QQ

  var ua = navigator.userAgent;
  // 适用于 uc qq 浏览器版本, 其它浏览器版本 待验证
  const browserVersion = (ua.split('/').slice(-2, -1)[0] || '').split(' ')[0] || 'unknown';

  var matchBS;

  // 微信浏览器
  if (ifWeChat) {
    return {
      browser: "微信内置浏览器",
      version: ua.match(/MicroMessenger\/(.+?)\s/i)[1]
    };
  }

  // UC浏览器
  matchBS = rUC.exec(ua);
  if (matchBS != null) {
    return {
      browser: "UC",
      version: browserVersion
    };
  }

  // QQ浏览器
  matchBS = rQQ.exec(ua);
  if (matchBS != null) {
    return {
      browser: "QQ",
      version: browserVersion
    };
  }

  return {
    browser: ua,
    version: ua
  };
}

export const setAutograph = (packageName, time) => {
  const skey = 'df34#4nL)74fS=';
  return md5(`package=${packageName}&timestamp=${time}&skey=${skey}`);
}

export const getPageType = (self) => {
  if (typeof self === 'number') {
    return self;
  }
  const pageType = self.$route.path.indexOf('app-home') !== -1
    ? Config.PAGE_TYPE.HOME
    : self.$route.path.indexOf('app-info') !== -1
    ? Config.PAGE_TYPE.INFO
    : '错误的路由地址';
  return pageType;
}

export const downloadFile = (src) => {
  let uuid = generateUUID();
  const $iframe = document.createElement('iframe');
  $iframe.id = 'down-file-iframe-' + uuid;
  $iframe.src = `${src}&page_title=h5info`;
  $iframe.style.display = 'none';
  $iframe.frameborder = 0;

  document.body.append($iframe);

}

/**
 * @func
 * @desc 生成全局唯一标识符 UUID
 */
export const generateUUID = () => {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
};
